import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import React from "react";
import { GiReturnArrow } from "react-icons/gi";

export const initialObservations = {
  id: null,
  observation: "",
  type: "",
  category: "",
  subCategory: "",
  potential: "",
  severity: "",
};

export const initialWorkMenInteraction = {
  id: null,
  workmenInteractedWith: "",
  operationBrief: "",
  workmenUnderstandingOnSafety: "",
  safetyProvidedToWorkmen: "",
  remark: "",
};

export const initialWorkMenInteractionWith = {
  type: "",
  userId: "",
};

export const evidenceTypes = {
  photo: "Photo",
  video: "Video",
  audio: "Audio",
};

export const initialEvidence = {
  incidentDetailsId: null,
  id: null,
  type: Object.keys(evidenceTypes)[0],
  description: "",
  file: null,
  fileId: null,
  category: "vfl",
};

export const initialCapa = {
  incidentDetailsId: null,
  capaId: "",
  source: "vfl",
  solution: "",
  priority: "",
  actionsOrResolutions: "",
  dueDate: "",
  completionDate: null,
  capaStatus: "Open",
  ownerId: null,
  departmentId: null,
  completionProofId: null,
  siteId: null,
  workAreaId: null,
  areaId: null,
  subAreaId: null,
  capaType: null,
};

export const initialForm = {};

export const Department = [
  { label: "Mining", id: "Mining" },
  { label: "Mechanical", id: "Mechanical" },
  { label: "Electrical", id: "Electrical" },
  { label: "Civil", id: "Civil" },
  { label: "Personal", id: "Personal" },
  { label: "Survey", id: "Survey" },
  { label: "Security", id: "Security" },
  { label: "IT", id: "IT" },
];

export const POTENTIAL = [
  { label: "First Aid Injury (FAI)", id: "FAI" },
  { label: "Medical Treatment Injury (MTI)", id: "MTI" },
  { label: "Lost Time Injury (LTI)", id: "LTI" },
  { label: "Fatality (F)", id: "fatality" },
];

export const OBSERVATION_TYPE = [
  { label: "Unsafe Act", id: "unsafeAct" },
  { label: "Unsafe Condition", id: "unsafeCondition" },
  { label: "Safe Act", id: "safeAct" },
  { label: "Safe Condition", id: "safeCondition" },
  // { label: "Near Miss", id: "nearMiss" },
  // { label: "MTI (Medical Treatment Injury)", id: "MTI" },
  // { label: "LTI (Lost Time Injury)", id: "LTI" },
  // { label: "Serious bodily injury", id: "SBI" },
  // { label: "Fatality", id: "fatality" },
];

export const OBSERVATION_SEVERITY = [
  {
    label: "1",
    value: "1",
    id: "1",
    tooltip:
      "Improper placement/Improper position/Disorderly workplace/Poor house keeping",
  },
  {
    label: "2",
    value: "2",
    id: "2",
    tooltip: "Not using PPEs/Using improper tools or equipment/Space congestion",
  },
  {
    label: "3",
    value: "3",
    id: "3",
    tooltip: "Violation of rules/ regulation/ SOPs/Codes & Procedures",
  },
  {
    label: "4",
    value: "4",
    id: "4",
    tooltip: "Serious hazard - injury or potential to cause injury if not corrected",
  },
  {
    label: "5",
    value: "5",
    id: "5",
    tooltip:
      "Urgent danger- serious injury or fatality or potentiality to cause serious injury or fatality if not corrected",
  },
];

export const OBSERVATIONS_SEVERITY = [
  {
    label: "1",
    value: "1",
    id: "1",
    tooltip: "Untidy, doesn’t meet standards",
  },
  {
    label: "2",
    value: "2",
    id: "2",
    tooltip: "Untidy, blocks access. bad example",
  },
  {
    label: "3",
    value: "3",
    id: "3",
    tooltip: "Rules and Procedure violation",
  },
  {
    label: "4",
    value: "4",
    id: "4",
    tooltip: "Serious hazard, can cause serious injury if not corrected",
  },
  {
    label: "5",
    value: "5",
    id: "5",
    tooltip:
      "Imminent Danger, stop work and correct immediately, will cause serious injury or fatality",
  },
];

export const CAPA_DUE_DATE_GUIDE_LINE = [
  {
    priority: "Low",
    dueDate: "7 Days",
  },
  {
    priority: "Medium",
    dueDate: "3 Days",
  },
  {
    priority: "High",
    dueDate: "24 Hours",
  },
];

export const VFL_STATUS = {
  draft: "draft",
  overdue: "overDue",
  scheduled: "scheduled",
  assigned: "assigned",
  executed: "executed",
  rejected: "rejected",
  approved: "approved",
  capaCompleted: "Capa Completed",
  capaInProgress: "Capa InProgress",
  capaReviewed: "CAPA Reviewed",
  capaApproved: "CAPA Approved",
  completed: "completed",
  capaAssigned: "CAPA Assigned",
  ExecutiveReturn: "ExecutiveReturn",
  returnedVFL: "Returned VFL",
};

export const VFL_STATUS_VIEW = {
  draft: "Draft",
  overDue: "Over Due",
  scheduled: "Scheduled",
  assigned: "Assigned",
  executed: "Executed",
  rejected: "Scheduled (Rejected)",
  ExecutiveReturn: "Returned VFL",
  approved: "Approved",
  "Capa Completed": "CAPA Completed",
  "Capa InProgress": "CAPA InProgress",
  "CAPA Reviewed": "CAPA Reviewed",
  "CAPA Approved": "CAPA Approved",
  completed: "Completed",
};

export const workmenInteractionRules = [
  {
    field_name: "workmenInteractedWith",
    label: "Workmen Interacted with",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "operationBrief",
    label: "Brief about on-going Operations",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "workmenUnderstandingOnSafety",
    label: "Understanding of the Workmen on Safety",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "safetyProvidedToWorkmen",
    label: "Safety Briefing Provided to Workmen",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "remark",
    label: "Other Remarks	",
    type: "String",
    isRequired: true,
  },
];

export const observationRules = [
  {
    field_name: "observation",
    label: "Observation",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "type",
    label: "Type",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "category",
    label: "Category",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "subCategory",
    label: "Sub-Category",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "potential",
    label: "Potential",
    type: "String",
    isRequired: true,
  },
  {
    field_name: "severity",
    label: "Severity",
    type: "String",
    isRequired: true,
  },
];

export const getVFLStatusClass = (status, executiveReturn) => {
  console.log("Nish", status);
  switch (status) {
    case VFL_STATUS.draft:
      return "bg-dark text-white rounded text-center";
    case VFL_STATUS.overdue:
      return "red text-white rounded text-center";
    case VFL_STATUS.scheduled:
      return executiveReturn
        ? "bg-primary text-white rounded text-center px-1"
        : "orange text-white rounded text-center px-1";
    case VFL_STATUS.assigned:
      return "bg-primary text-white rounded text-center px-1";
    case VFL_STATUS.executed:
      return "green-300 text-white rounded text-center";
    case VFL_STATUS.rejected:
      return "bg-primary text-white rounded text-center px-1";
    case VFL_STATUS.returnedVFL:
      return "bg-primary text-white rounded text-center px-1";
    case VFL_STATUS.approved:
      return "success";
    case VFL_STATUS.capaCompleted:
      return "green-300 text-white rounded text-center";
    case VFL_STATUS.capaAssigned:
      return "yellow text-white rounded text-center";
    case VFL_STATUS.capaInProgress:
      return "orange text-white rounded text-center";
    case VFL_STATUS.capaReviewed:
      return "orange text-white rounded text-center";
    case VFL_STATUS.capaApproved:
      return "orange text-white rounded text-center";
    case VFL_STATUS.completed:
      return "success";
    default:
      return "notstarted";
  }
};

export const contractorInvolvedView = {
  yes: "Yes",
  no: "No",
};

export const incidentFilterFields = [
  {
    name: "vflExecutiveId",
    title: "VFL Executive",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "contractorInvolved",
    title: "Contractor",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
  },
  {
    name: "mineId",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "dateRange",
    title: "Date Range",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "areaId",
    title: "Area",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "subAreaId",
    title: "Sub Area",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "departmentId",
    title: "Department",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Department.map((d) => ({ ...d, value: d.id })),
  },
  {
    name: "activityId",
    title: "Activity",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "subActivityId",
    title: "Sub Activity",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "roId",
    title: "Location Name",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "vflScheduledBy",
    title: "Scheduled By",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "vflStatus",
    title: "VFL Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(VFL_STATUS_VIEW).map((k) => ({
      label: VFL_STATUS_VIEW[k],
      value: k,
    })),
  },
  // {
  //   name: "name",
  //   title: "Name",
  //   inputType: EFormFieldInputTypes.text,
  // },
];

export const VFL_STATUS_COLUMN = (statusKey, row) => {
  return (
    <div className={getVFLStatusClass(statusKey, row?.executiveReturn)}>
      {!row?.executiveReturn ? (
        row?.vflStatusView
      ) : (
        <>
          {VFL_STATUS_VIEW?.ExecutiveReturn}
          <GiReturnArrow className="ml-2" size={18} />
        </>
      )}
    </div>
  );
};

export const checkVflStatusFilter = (status, data) => {
  let flag = false;
  if (
    status === VFL_STATUS.ExecutiveReturn &&
    data.vflStatus === VFL_STATUS.scheduled &&
    data.executiveReturn
  )
    flag = true;
  else if (
    status === VFL_STATUS.scheduled &&
    data.vflStatus === VFL_STATUS.scheduled &&
    !data.executiveReturn
  )
    flag = true;
  else if (data.vflStatus !== VFL_STATUS.scheduled && data.vflStatus === status)
    flag = true;
  return flag;
};
